<template>
  <!--服务器详情页面-->
  <div
    class="server-body"
    :class="{ 'desk-page': this.device === 'desktop' }"
  >
    <!--loading-->
    <loading :complete="complete"></loading>
    <!--头部-->
    <tk-flex
      middle
      class="header"
      :class="{
        'header-mobile': this.device === 'mobile',
        'header-pc': this.device === 'desktop'
      }"
    >
      <div @click="$back()" class="header-icon pointer-btn m-r-15">
        <tk-icon :color="'#15172f'" :size="18">recede</tk-icon>
      </div>
      默客科技服务器优势
    </tk-flex>
    <div style="height: 45px;"></div>
    <!--图片-->
    <div
      class="qa-image"
      :style="`background-image: url(${device === 'mobile' ? imageUrls.serverAMobile : imageUrls.serverAPc}) !important`"
    >
      <div class="text-white font-24 font-bold">99.9%的软件都需要</div>
      <div class="text-white font-24 font-bold">服务器</div>
      <div class="text-white font-12 m-t-15">软件反应<span class="text-red">“慢"</span>，多半就是<span class="text-red">服务器“慢”</span></div>
    </div>
    <!--一般服务器-->
    <tk-flex middle class="body-general p-x-15">
      <div class="general-image">
        <tk-image src="http://moke-store.oss-cn-beijing.aliyuncs.com/f71efc9d-bdbf-47f3-a51b-e6ac5bfad928.png" :width="99" :height="202"></tk-image>
      </div>
      <tk-flex center column class="m-l-30 full-width">
        <div class="block-title">一般软件的服务器</div>
        <tk-flex middle between class="full-width">
          <tk-flex column>
            <div class="font-14 font-bold">双核8G</div>
            <div class="text-grey m-t-10 font-12">内存</div>
          </tk-flex>
          <div class="general-line"></div>
          <tk-flex column>
            <div class="font-14 font-bold">5M</div>
            <div class="text-grey m-t-10 font-12">带宽</div>
          </tk-flex>
          <div class="general-line"></div>
          <tk-flex column>
            <div class="font-14 font-bold">150G</div>
            <div class="text-grey m-t-10 font-12">硬盘</div>
          </tk-flex>
        </tk-flex>
        <div class="text-orange font-bold font-14 m-t-20">性能甚至不如你的手机</div>
        <div class="font-12 m-t-15 text-grey tk-grid-11">不使用任何附加服务，一年<span class="text-orange">5500元</span></div>
        <div class="font-12 text-grey text-left tk-grid-11">（阿里云2020最新价格）</div>
      </tk-flex>
    </tk-flex>
    <!--moke使用服务器-->
    <tk-flex center column class="body-moke p-x-15 full-width">
      <div class="block-title p-t-10">默客使用的服务器</div>
      <!--服务器数据列表-->
      <moke-list
        title="阿里云OSS服务"
        :ali-image="device === 'mobile' ? imageUrls.serverBMobile : imageUrls.serverBPc"
        :ali-data="aliOss"
      >
        <tk-flex middle class="p-15 full-width">
          <div class="m-l-28"></div>
          <tk-flex between class="m-l-12 full-width">
            <tk-flex center column>
              <tk-image src="http://moke-store.oss-cn-beijing.aliyuncs.com/ec755d70-7d5a-4b19-9e7c-436999b3177a.png" :width="124" :height="116"></tk-image>
              <div class="font-12 text-gray m-t-2">用户上传原图</div>
              <div class="font-12 text-gray m-t-2">大小3M</div>
            </tk-flex>
            <tk-flex center middle class="font-12 text-gray" style="height: 115px;">VS</tk-flex>
            <tk-flex center column>
              <tk-image src="http://moke-store.oss-cn-beijing.aliyuncs.com/ec755d70-7d5a-4b19-9e7c-436999b3177a.png" :width="124" :height="116"></tk-image>
              <div class="font-12 text-gray m-t-2">页面显示</div>
              <div class="font-12 text-gray m-t-2">大小30k</div>
            </tk-flex>
          </tk-flex>
        </tk-flex>
      </moke-list>
      <moke-list
        class="m-t-20"
        title="阿里云云数据库"
        :ali-image="device === 'mobile' ? imageUrls.serverCMobile : imageUrls.serverCPc"
        :ali-data="aliDatabase"
      >
      </moke-list>
      <moke-list
        class="m-t-20"
        title="阿里云容器服务"
        :ali-image="device === 'mobile' ? imageUrls.serverDMobile : imageUrls.serverDPc"
        :ali-data="aliContainer"
      >
      </moke-list>
      <!--专业提示-->
      <div
        class="tips-image m-t-20"
        :style="`background-image: url(${device === 'mobile' ? imageUrls.serverEMobile : imageUrls.serverEPc}) !important`"
      >
        <div class="text-white font-24 font-bold">专业服务器，当然需要</div>
        <div class="text-white font-24 font-bold">专业运维</div>
        <tk-flex middle class="text-white font-12 m-t-15">
          <div>
            <tk-icon color="#fffffff" class="m-r-5" :size="12">zhengque</tk-icon>定期健康检查
          </div>
          <div class="m-l-12">
            <tk-icon color="#fffffff" class="m-r-5" :size="12">zhengque</tk-icon>24小时监控
          </div>
        </tk-flex>
        <div class="text-orange font-12 m-t-10">
          <tk-icon color="#f44f3d" class="m-r-5" :size="12">zhengque</tk-icon>实时处理异常情况
        </div>
      </div>
      <tk-flex center middle column class="m-t-24 slogan-tip font-bold">
        <div class="font-24">在默客开发软件，以上服务</div>
        <div class="font-24 text-orange m-t-5">2年内免费提供</div>
      </tk-flex>
    </tk-flex>
    <!--常见问题-->
    <tk-flex center column class="m-t-20">
      <div class="block-title">您可能关心的问题</div>
      <qa-problem :qa="commonProblem"></qa-problem>
    </tk-flex>
    <tk-flex middle center class="server-footer">以上内容解释权归谨思科技所有</tk-flex>
  </div>
</template>

<script>
import mokeList from '@/components/mokeList'
import qaProblem from '@/components/commonProblem'
import loading from '@/components/loading'
import { aliOss, aliDatabase, imageUrl,
  aliContainer, commonProblem } from '@/assets/js/qa'
import gql from 'graphql-tag'
export default {
  name: 'server',
  components: {
    mokeList,
    qaProblem,
    loading
  },
  data () {
    return {
      data: null,
      imageUrls: imageUrl,
      complete: true,
      aliOss: aliOss,
      aliDatabase: aliDatabase,
      aliContainer: aliContainer,
      commonProblem: commonProblem
    }
  },
  apollo: {
    $subscribe: {
      data: {
        query: gql`subscription quotationSubscription($id: Int!) {
        quotation_by_pk (id: $id) {
          id
          title
          modules
          price
          duration
          result
          suggest
          service
          updated_at
        }
      }`,
        result (res, key) {
          this.data = res.data.quotation_by_pk
          let title = res.data && res.data.quotation_by_pk && res.data.quotation_by_pk.title ? res.data.quotation_by_pk.title : ''
          if (title) {
            document.title = '默客科技-' + title
          }
        },
        variables () {
          return {
            id: Number(this.id)
          }
        }
      }
    }
  },
  computed: {
    id () {
      return this.$route.query.id
    }
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  activated () {
    setTimeout(() => { this.complete = false }, 1000)
  },
  methods: {
    isInclude (type, key) {
      if (!this.data) return false
      return this.data[type].findIndex(k => k === key) > -1
    }
  }
}
</script>
<style lang="scss" scoped>
  .server-body {
    width: 100%;
    height: 100%;
    background: #ffffff;
    .block-title {
      display: inline-block;
      font-size: 20px;
      color: rgba(67, 67, 159, 1);
      font-weight: bolder;
      border-bottom: 5px solid rgba(245, 79, 61, 1);
      line-height: 14px;
      padding: 0 4px;
      margin: 21px 0 20px;
    }
    /*头部样式*/
    .header {
      height: 45px;
      top: 0;
      width: calc(60%);
      z-index: 9999;
      line-height: 45px;
      background: #ffffff;
      font-weight: bold;
      position: fixed;
      color: #2d2d49;
      border-bottom: 1px solid rgba(240, 240, 240, 1);
      padding: 0 15px;
      .header-icon {
        width: 32px;
        height: 32px;
        line-height: 32px;
        text-align: center;
      }
    }
    .header-mobile {
      width: 100%;
    }
    .header-pc {
      width: calc(60%);
    }
    /*首张图片样式*/
    .qa-image {
      width: 100%;
      min-height: 150px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: 50%;
      object-fit: cover;
      padding: 35px 21px;
    }
    /*一般软件服务器样式*/
    .body-general {
      margin-top: 42px;
      .general-line {
        width: 1px;
        height: 32px;
        background-color: #eaeaea;
      }
    }
    /*moke使用服务器样式*/
    .body-moke {
      margin-top: 30px;
      background: #f7fafc;
      .tips-image {
        width: 100%;
        min-height: 150px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: 50%;
        object-fit: cover;
        padding: 24px 15px;
      }
      .slogan-tip {
        padding: 24px 25px;
      }
    }
    /*底部样式*/
    .server-footer {
      height: 42px;
      font-size: 10px;
      color: #898995;
      font-style: italic;
    }
  }
</style>
